
import Vue from 'vue';
import { Data as ArticleData } from '@root/modules/article/types/article';

interface Props {
  adsDisabled: boolean;
  articleId: ArticleData['id'];
}

interface Computed {
  maintenanceMode: boolean;
  hideOrdering: boolean;
  isComposerTarget: boolean;
}

export default Vue.extend<unknown, unknown, Computed, Props>({
  props: {
    adsDisabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    articleId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    maintenanceMode() {
      return this.$store.state.piano.config.maintenanceMode;
    },
    hideOrdering() {
      const { specialFeatures } = this.$channelConfig('settings').application;
      return specialFeatures.hideSignupAndOrders.enabled;
    },
    isComposerTarget() {
      return this.articleId === this.$store.state.article.composerTarget;
    },
  },
  async mounted() {
    const unwatch = this.$store.watch(
      (state) => state.piano.experience.ready,
      async (ready: boolean) => {
        if (this.isComposerTarget && ready) {
          this.$store.dispatch('piano/executeExperience');
          await this.$nextTick();
          unwatch();
        }
      },
      {
        immediate: true,
      }
    );
  },
});
